import { isAfter, isBefore, isFuture } from "date-fns";

export const _commonEventLegalsReq = Object.freeze(["terms", "rules"]);


export const validateLegalSigns = async (currentLegalsEntries, getUserSigns, reqLegalPaths = []) => {
    let isMissing = false;

    const requiredListRaw = await Promise.all(currentLegalsEntries.map(async ([path, lgl]) => {
        if (!reqLegalPaths.includes(path)) { return; }

        const field = lgl.signFieldName;
        const btn = lgl.signBtn;

        const signedAt = field && await getUserSigns(field);
        const requireSign = field && btn && !isAfter(signedAt, lgl.validFrom);
        if (requireSign) { isMissing = true; }

        return { legal: lgl, signedAt, requireSign };
    }));

    const requiredList = requiredListRaw.filter(Boolean);

    return { isMissing, requiredList };
}